"use client";

import { useHydrated } from "./useHydrated";
import { usePrefersReducedMotion } from "./usePrefersReducedMotion";

/**
 * True when an entrance animation must not play — the shared gate for every
 * entrance component (Reveal, HeroDevices).
 *
 * Contract: while this is true, render the resting layout directly and mount
 * NO motion element. Only once it flips false may the motion element mount,
 * so its `initial` pose applies at its actual mount (motion/react resolves
 * `initial` at mount only — toggling the prop later does nothing).
 *
 * SEO/no-JS: it is true during SSR and the hydration render, so
 * server-rendered HTML is always the fully visible resting state; crawlers
 * and no-JS readers never see a hidden pose. It stays true permanently for
 * prefers-reduced-motion users.
 */
export function useEntranceStill(): boolean {
  const hydrated = useHydrated();
  const reduceMotion = usePrefersReducedMotion();
  return reduceMotion || !hydrated;
}
